import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/midders/Code/xedi-microservices/sdk-js/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { CheckIcon } from '@primer/styled-octicons';
import { Link } from "gatsby";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Introduction`}</h2>
    <p>{`The Transitions API gives the ability to fully configure each transition between the `}<Link to="/docs/usage/stages" mdxType="Link">{`stages`}</Link>{` of a work flow `}<Link to="/docs/usage/templates" mdxType="Link">{`template`}</Link>{`.`}</p>
    <h2>{`Usage`}</h2>
    <h3>{`list`}</h3>
    <p>{`Retreive the list of transitions.`}</p>
    <p><strong parentName="p">{`Usage`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const transitions = await Xedi.Transitions.list();
`}</code></pre>
    <p><strong parentName="p">{`Response`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
  {
      "_id": "5076455a-a18e-11ea-8618-0242ac120002",
      "from_id": "9cabdeca-a0fe-11ea-8530-0242ac120002",
      "to_id": "a099e2de-a0fe-11ea-b9be-0242ac120002",
      "workflow_id": "9c82245e-a0fe-11ea-b1cf-01009cb3fa40",
      "workflow_type": "template",
      "description": "My first transition",
      "is_automtic": 1,
      "created_at": "2020-05-11 10:27:03",
      "updated_at": "2020-05-11 10:27:03"
  }
  {
    "_id": "574612ac-a18e-11ea-ac77-0242ac120002",
    "from_id": "9cabdeca-a0fe-11ea-8530-0242ac120002",
    "to_id": "a099e2de-a0fe-11ea-b9be-0242ac120002",
    "workflow_id": "9c82245e-a0fe-11ea-b1cf-01009cb3fa40",
    "workflow_type": "template",
    "description": "My second transition",
    "is_automtic": 1,
    "created_at": "2020-05-11 10:27:03",
    "updated_at": "2020-05-11 10:27:03"
  }
]
`}</code></pre>
    <h3>{`get`}</h3>
    <p>{`Retrieve a transition by Id.`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'5076455a-a18e-11ea-8618-0242ac120002'`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Usage`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const transition = await Xedi.Transitions.get('5076455a-a18e-11ea-8618-0242ac120002');
`}</code></pre>
    <p><strong parentName="p">{`Response`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "_id": "5076455a-a18e-11ea-8618-0242ac120002",
    "from_id": "9cabdeca-a0fe-11ea-8530-0242ac120002",
    "to_id": "a099e2de-a0fe-11ea-b9be-0242ac120002",
    "workflow_id": "9c82245e-a0fe-11ea-b1cf-01009cb3fa40",
    "workflow_type": "template",
    "description": "My first transition",
    "is_automtic": 1,
    "created_at": "2020-05-11 10:27:03",
    "updated_at": "2020-05-11 10:27:03"
}
`}</code></pre>
    <h3>{`create`}</h3>
    <p>{`Create a transition`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`from_id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`"9cabdeca-a0fe-11ea-8530-0242ac120002"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`to_id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`"a099e2de-a0fe-11ea-b9be-0242ac120002"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`workflow_id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`"9c82245e-a0fe-11ea-b1cf-01009cb3fa40"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`description`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`My first transition`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`is_automtic`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Usage`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const transition = await Xedi.Transitions.create(
  {
    from_id: '9cabdeca-a0fe-11ea-8530-0242ac120002',
    to_id: 'a099e2de-a0fe-11ea-b9be-0242ac120002',
    workflow_id: '9c82245e-a0fe-11ea-b1cf-01009cb3fa40',
    workflow_type: 'template',
    description: 'My first transition',
    is_automtic: 1
  }
);
`}</code></pre>
    <p><strong parentName="p">{`Response`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "_id": "5076455a-a18e-11ea-8618-0242ac120002",
    "from_id": "9cabdeca-a0fe-11ea-8530-0242ac120002",
    "to_id": "a099e2de-a0fe-11ea-b9be-0242ac120002",
    "workflow_id": "9c82245e-a0fe-11ea-b1cf-01009cb3fa40",
    "workflow_type": "template",
    "description": "My first transition",
    "is_automtic": 1,
    "created_at": "2020-05-11 10:27:03",
    "updated_at": "2020-05-11 10:27:03"
}
`}</code></pre>
    <h3>{`update`}</h3>
    <p>{`Update a transition`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`"5076455a-a18e-11ea-8618-0242ac120002"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`from_id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`"9cabdeca-a0fe-11ea-8530-0242ac120002"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`to_id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`"a099e2de-a0fe-11ea-b9be-0242ac120002"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`workflow_id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`"9c82245e-a0fe-11ea-b1cf-01009cb3fa40"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`description`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`My first transition`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`is_automtic`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Usage`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const transition = await Xedi.Transitions.create(
  {
    _id: '5076455a-a18e-11ea-8618-0242ac120002',
    from_id: '9cabdeca-a0fe-11ea-8530-0242ac120002',
    to_id: 'a099e2de-a0fe-11ea-b9be-0242ac120002',
    workflow_id: '9c82245e-a0fe-11ea-b1cf-01009cb3fa40',
    workflow_type: 'template',
    description: My updated transition,
    is_automtic: 1
  }
);
`}</code></pre>
    <p><strong parentName="p">{`Response`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "_id": "5076455a-a18e-11ea-8618-0242ac120002",
    "from_id": "9cabdeca-a0fe-11ea-8530-0242ac120002",
    "to_id": "a099e2de-a0fe-11ea-b9be-0242ac120002",
    "workflow_id": "9c82245e-a0fe-11ea-b1cf-01009cb3fa40",
    "workflow_type": "template",
    "description": "My updated transition",
    "is_automtic": 1,
    "created_at": "2020-05-11 10:27:03",
    "updated_at": "2020-05-11 10:27:03"
}
`}</code></pre>
    <h3>{`Delete`}</h3>
    <p>{`Delete a transition.`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'5076455a-a18e-11ea-8618-0242ac120002'`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Usage`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const transition = await Xedi.Transitions.delete('5076455a-a18e-11ea-8618-0242ac120002');
`}</code></pre>
    <p><strong parentName="p">{`Response`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "_id": "5076455a-a18e-11ea-8618-0242ac120002"
}
`}</code></pre>
    <h3>{`Transition`}</h3>
    <p>{`Transition between two stages as defined by the given Transition`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'5076455a-a18e-11ea-8618-0242ac120002'`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Usage`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const transition = await Xedi.Transitions.transition('5076455a-a18e-11ea-8618-0242ac120002');
`}</code></pre>
    <p><strong parentName="p">{`Response`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "_id": "5076455a-a18e-11ea-8618-0242ac120002",
    "from_id": "9cabdeca-a0fe-11ea-8530-0242ac120002",
    "to_id": "a099e2de-a0fe-11ea-b9be-0242ac120002",
    "workflow_id": "9c82245e-a0fe-11ea-b1cf-01009cb3fa40",
    "workflow_type": "template",
    "description": "My updated transition",
    "is_automtic": 1,
    "created_at": "2020-05-11 10:27:03",
    "updated_at": "2020-05-11 10:27:03"
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      